import React, { Component } from 'react';
const {MDBCol} = require('mdbreact')

interface ColProps {
    xs?:string;
    sm?:string;
    md?:string;
    lg?:string;
    className?:string;
}

class Col extends Component<ColProps,{}> {

    constructor (props:ColProps) {
        super(props)
    }

    render() {
        const props = this.props as  {[key:string]:string};
        let sizes = ['xs','sm','md','lg']
        let className = 'ui-renderer-col ' + (this.props.className ? ' ' + this.props.className : '');
        sizes.map(ele => { if(props[ele] === '0') className += ' '+ele+'-hide' })
        
        return (
            <MDBCol
                xs={this.props.xs}
                sm={this.props.sm}
                md={this.props.md}
                lg={this.props.lg}
                className={className}
            >
                {this.props.children}
            </MDBCol>
        );
    }
}


export default Col;
